import { Table, Avatar, Pagination, Select, Tooltip } from "antd";
import React, { useState } from "react";
import ToggleSwitch from "../../CommonComponents/ToggleSwitch/ToggleSwitch";
import { Button } from "antd";
import { EditOutlined, CalendarOutlined, CloseOutlined, SafetyCertificateFilled, LoadingOutlined, ShieldFilled } from "@ant-design/icons";
import "./UsersTable.css";

// import "../../Transactions/stylesTransactionRoutes.css";
import { render } from "@testing-library/react";
import { useNavigate } from "react-router-dom";
import { NAVIGATION_ROUTES } from "../../../utils/NavigationUtils";

const sampleData = [
  {
    key: 1,
    userId: "0000000001",
    name: "LuckyPlayer",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    email: "lucky@example.com",
    firstName: "Jane",
    lastName: "Cooper",
    phone: "+1 (202) 555-0143",
    finixBankAccount: "Jane Cooper",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-08",
    location: "2927 Westinmark Rd, Santa Ana, Illinois 85486",
    lastEntry: "Jul 08, 2025 01:35 PM",
    limitations: "Time limits, Currency",
    notes: "VIP client",
  },
  {
    key: 2,
    userId: "0000000002",
    name: "BetMaster",
    avatar: "https://randomuser.me/api/portraits/men/33.jpg",
    email: "betmaster@example.com",
    firstName: "Esther",
    lastName: "Howard",
    phone: "+1 (303) 555-0198",
    finixBankAccount: "Esther Howard",
    kyc: "Pending",
    status: "Suspended",
    referralCode: "U-GOL-UAR-08",
    location: "1901 Thorridge Cir, Shiloh, Hawaii 81083",
    lastEntry: "Oct 05, 2024 12:34 PM",
    limitations: "Wager limits",
    notes: "Awaiting KYC verification",
  },
  {
    key: 3,
    userId: "0000000003",
    name: "HighRoller",
    avatar: "https://randomuser.me/api/portraits/men/34.jpg",
    email: "roller@example.com",
    firstName: "Cameron",
    lastName: "Williamson",
    phone: "+1 (415) 555-0127",
    finixBankAccount: "Cameron Williamson",
    kyc: "Pending",
    status: "Suspended",
    referralCode: "U-GOL-UAR-08",
    location: "2118 Thorridge Cir, Syracuse, Connecticut 35924",
    lastEntry: "Nov 10, 2024 05:45 PM",
    limitations: "Wager limits",
    notes: "Suspended due to fraud",
  },
  {
    key: 4,
    userId: "0000000004",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Pending",
    status: "Delete",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 5,
    userId: "0000000005",
    name: "Gambler",
    avatar: "https://randomuser.me/api/portraits/women/45.jpg",
    email: "gamblerjoy@example.com",
    firstName: "Jenny",
    lastName: "Wilson",
    phone: "+1 (702) 555-0176",
    finixBankAccount: "Jenny Wilson",
    kyc: "Pending",
    status: "Active",
    referralCode: "U-GOL-UAR-35",
    location: "8502 Preston Rd, Inglewood, Maine 98380",
    lastEntry: "Jul 08, 2025 01:35 PM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 6,
    userId: "0000000006",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/46.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 7,
    userId: "0000000007",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/47.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 8,
    userId: "0000000008",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/48.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 9,
    userId: "0000000009",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/49.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 10,
    userId: "0000000010",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/50.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 11,
    userId: "0000000011",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/51.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 12,
    userId: "0000000012",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/52.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 13,
    userId: "0000000013",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/53.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 14,
    userId: "0000000014",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/54.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 15,
    userId: "0000000015",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/55.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  {
    key: 16,
    userId: "0000000016",
    name: "JaneDoe",
    avatar: "https://randomuser.me/api/portraits/women/56.jpg",
    email: "jane@example.com",
    firstName: "Leslie",
    lastName: "Alexander",
    phone: "+1 (617) 555-0189",
    finixBankAccount: "Leslie Alexander",
    kyc: "Verified",
    status: "Active",
    referralCode: "U-GOL-UAR-10",
    location: "2716 Ash Dr, San Jose, South Dakota 83475",
    lastEntry: "Jan 14, 2025 08:20 AM",
    limitations: "-",
    notes: "-",
  },
  // ...add more rows as needed, following the same structure
];

const columns = [
  {
    title: "User ID",
    dataIndex: "userId",
    key: "userId",
    sorter: (a, b) => a.userId.length - b.userId.length,
  },
  {
    title: "Username",
    dataIndex: "name",
    key: "name",
    render: (text, record) => (
      <div className="username-cell">
        <Avatar src={record.avatar} size={32} />
        <span className="username-text">{text}</span>
      </div>
    ),
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "First Name",
    dataIndex: "firstName",
    key: "firstName",
    
  },
  {
    title: "Last Name",
    dataIndex: "lastName",
    key: "lastName",
    
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    
  },
  {
    title: "Finix Bank Account",
    dataIndex: "finixBankAccount",
    key: "finixBankAccount",
    
  },
  {
    title: "KYC",
    dataIndex: "kyc",
    key: "kyc",
    sorter: (a, b) => a.kyc.length - b.kyc.length,
    render: (text) => {
      if (text === "Verified") {
        return (
          <div className="kyc-cell">
            <SafetyCertificateFilled className="kyc-icon verified" />
            <span className="kyc-text">Verified</span>
          </div>
        );
      } else if (text === "Pending") {
        return (
          <div className="kyc-cell">
            <LoadingOutlined className="kyc-icon pending" />
            <span className="kyc-text">Pending...</span>
          </div>
        );
      } else {
        return text;
      }
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    sorter: (a, b) => a.status.length - b.status.length,
    render: (text) => {
      let badgeClass = "status-badge status-default";
      if (text === "Active") badgeClass = "status-badge status-active";
      else if (text === "Suspended") badgeClass = "status-badge status-suspended";
      else if (text === "Limited") badgeClass = "status-badge status-limited";
      else if (text === "Delete") badgeClass = "status-badge status-delete";
      return <span className={badgeClass}>{text}</span>;
    },
  },
  {
    title: "Referral Code",
    dataIndex: "referralCode",
    key: "referralCode",
    
  },
  {
    title: "Location",
    dataIndex: "location",
    key: "location",
    ellipsis: true,
    render: (text) => (
      <Tooltip placement="top" title={text} > 
        <span style={{ maxWidth: 120, display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "middle",  }}>
          {text}
        </span>
      </Tooltip>
    ),
  },
  {
    title: "Last entry",
    dataIndex: "lastEntry",
    key: "lastEntry",
    
  },
  {
    title: "Limitations",
    dataIndex: "limitations",
    key: "limitations",
    ellipsis: true,
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <span style={{ maxWidth: 120, display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "middle" }}>
          {text}
        </span>
      </Tooltip>
    ),
  },
  {
    title: "Notes",
    dataIndex: "notes",
    key: "notes",
    ellipsis: true,
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <span style={{ maxWidth: 120, display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "middle" }}>
          {text}
        </span>
      </Tooltip>
    ),
  },
  {
    title: "Actions",
    dataIndex: "Actions",
    key: "Actions",
    fixed: 'right',
    width: 180,
    render: (text, record) => {
      return (
        <div className="actions-cell">
          <EditOutlined className="action-icon edit-icon" />
          <CalendarOutlined className="action-icon calendar-icon" />
          <CloseOutlined className="action-icon delete-icon" />
        </div>
      );
    },
  },
];

function UsersTable({ data }) {
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(6);

  const navigate = useNavigate();
  

  const handlePageChange = (page, pageSize) => {
    setCurrent(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrent(1);
  };

  const paginatedData = sampleData.slice((current - 1) * pageSize, current * pageSize);

  return (
    // <div className="transaction-routes-container">
    //   <div className="transaction-routes-table">
    <>
      <Table
        columns={columns}
        dataSource={paginatedData}
        pagination={false}
        rowKey="key"
        scroll={{ x: 3000 }}
        rowClassName="users-table-row"
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              console.log('Linha clicada:', record, 'Índice:', rowIndex);
              navigate(NAVIGATION_ROUTES.PLAYERS)
            },
          };
        }}
      />
      <div className="custom-pagination-bar">
        <div className="pagination-left">
          <Select
            value={pageSize}
            onChange={size => handlePageSizeChange(current, size)}
            style={{ width: 80 }}
            options={[
              { value: 6, label: '6' },
              { value: 12, label: '12' },
              { value: 24, label: '24' },
              { value: 48, label: '48' },
              { value: 96, label: '96' },
            ]}
            dropdownStyle={{ background: '#23232b', color: '#b0b0b0' }}
          />
          <span className="result-per-page-label">Result per page</span>
        </div>
        <div className="pagination-right">
          <Pagination
            current={current}
            pageSize={pageSize}
            total={sampleData.length}
            onChange={handlePageChange}
            showSizeChanger={false}
            showQuickJumper={false}
            itemRender={(page, type, originalElement) => originalElement}
          />
        </div>
      </div>
    </>
  );
}

export default UsersTable;
